module.exports = "<p>\n  job-costing-bout-inspector works!\n</p>\n"